import { Color } from "@/common/colors/colors";
import styled from "styled-components";

export const StepsRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

export const StepChip = styled.div`
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  color: ${Color.White};
  background: ${(props) =>
    props.$active ? Color.DarkBlue : props.$done ? Color.green : Color.Grey};
`;

export const Hint = styled.p`
  max-width: 520px;
  color: ${Color.DarkGrey};
  font-size: 13px;
`;

export const LanguageLabel = styled.p`
  font-weight: 600;
`;

export const ChoiceRow = styled.div`
  display: flex;
  gap: 12px;
  margin: 16px 0;
`;
